// extracted by mini-css-extract-plugin
export default {"SuccessIcon":"InlineForm_SuccessIcon__+CQ9B","Icon":"InlineForm_Icon__kb6rN","NoteText":"InlineForm_NoteText__XMZ8z","AdditionText":"InlineForm_AdditionText__j-v0e"};